import { useContext } from "react";
import useSWR from "swr";

import { UserContext } from "../context";
import { URL, Fetcher as F } from "../api";

export const useDepartment = () => {
  const {
    token: { access },
  } = useContext(UserContext);
  const canFetch = access != null;
  const { data: departmentList = [] } = useSWR(
    canFetch ? [URL.department] : null,
    F.withToken,
    { revalidateOnFocus: false }
  );

  return departmentList;
};
